import React, { Component } from "react";
import Auth from "../services/authService";
import ExternalLink from "./common/externalLink";

const TOS_URL =
  "https://firebasestorage.googleapis.com/v0/b/uni-notas.appspot.com/o/termsAndConditions.html?alt=media&token=effc742f-0fc8-4cb5-9742-c934a8690259";

class Login extends Component {
  render() {
    return (
      <div className="text-center" style={{ marginTop: 200 }}>
        <h4 className="text-secondary">
          Veja como as universidades angolanas foram avaliadas pelos seus
          estudantes e/ou avalie a sua universidade
        </h4>
        <Auth />
        <p style={{ fontSize: 13 }}>
          Ao continuar estará concordando com os
          <ExternalLink
            url={TOS_URL}
            label=" termos e condições de serviço"
          ></ExternalLink>
          .
        </p>
      </div>
    );
  }
}

export default Login;
